<template>
    <div class="card" :class="open ? 'opened' : ''">
      <div class="card-header">
        <button @click="() => open = !open" class="d-flex w-100 justify-content-between align-items-center" type="button" data-toggle="collapse" data-target="#organisationSettingsCollapse" aria-expanded="false" aria-controls="organisationSettingsCollapse">
          <h4 data-target="#organisationSettingsCollapse" aria-expanded="false" aria-controls="organisationSettingsCollapse" class="mb-0">Կազմակերպության տվյալներ</h4>
          <svg width="14" height="8" viewBox="0 0 14 8">
            <path d="M8.40545 6.48276L13.2227 1.51724L11.7507 -6.43398e-08L6.93353 4.96552L2.25014 -4.79624e-07L0.778211 1.51724L5.4616 6.48276L6.93353 8L8.40545 6.48276Z" fill="#006BE6"/>
          </svg>
          <span v-tooltip="'Կազմակերպության տվյալները փոփոխելու հնարավորություն ունի միայն համակարգողը'" v-if="!isCoordinator">
            <i class="fas fa-question-circle"></i>
          </span>
        </button>
      </div>
      <div id="organisationSettingsCollapse" class="collapse multi-collapse">
        <div class="card-body d-flex flex-column padding-20">
            <div>
                <div v-if="fields.verification_status === 'verified'" class="alert alert-success d-flex align-items-center mb-3" style="width: fit-content;">
                  <span v-if="fields.is_resident">✓ ՀՀ պետական ռեգիստրով ստուգված<span v-if="fields.verification_checked_at">, Վերջին ստուգում՝ {{ formatVerificationDate(fields.verification_checked_at) }}</span></span>
                  <span v-else>✓ Օտարերկրյա կազմակերպություն — ստուգված</span>
                </div>
              <form class="form-parsley" :key="dataLoaded">
                <!-- Email / Phone
                <div class="form-row">
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="text-secondary" >
                      <input
                        :disabled="!isCoordinator"
                        id="email"
                        v-model="$v.fields.email.$model"
                        type="email"
                        :placeholder="$t('home.subscribe-area.placeholder')"
                        class="form-control"
                        :class="{'border-danger': isInvalidField('email', 'required') || isInvalidField('email', 'email')}"
                        name="r_mail"
                      />
                    </float-label>
                    <div v-if="isInvalidField('email', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                    <div v-if="isInvalidField('email', 'email')" class="small text-danger">{{ $t('state_customer.valid_2') }}</div>
                  </div>
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label >
                      <the-mask
                        :disabled="!isCoordinator"
                        id="phone"
                        v-model="$v.fields.phone.$model"
                        :validCharactersOnly="true"
                        class="form-control"
                        :placeholder="$t('state_customer.pl_tel')"
                        :class="{'border-danger': isInvalidField('phone', 'required') || isInvalidPhone}"
                        mask="+(374) ##-##-##-##" 
                        name="r_phone"
                        @validate="validatePhone"
                      />
                    </float-label>
                    <div v-if="isInvalidField('phone', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                    <div v-else-if="isInvalidPhone" class="small text-danger">{{ $t('state_customer.valid_3') }}</div>
                  </div>
                </div> -->

                <!-- Companny / Company RU -->




                <div v-if="type === 'legalEntity'">
                  <div class="form-row">
                    <div class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <input
                          :disabled="$v.fields.name.hy.$model"
                          v-if="isPrivate"
                          v-model="$v.fields.name.hy.$model"
                          :placeholder="$t('private_customer.user_name')"
                          type="text"
                          name="company_name"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('name.hy', 'required')}"
                        />
                        <input
                          :disabled="$v.fields.name.hy.$model"
                          v-else
                          v-model="$v.fields.name.hy.$model"
                          :placeholder="$t('state_customer.pl_name')"
                          type="text"
                          name="company_name"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('name.hy', 'required')}"
                        />
                      </float-label>  
                      <div v-if="isInvalidField('name.hy', 'required')"
                        class="small text-danger">{{ $t('state_customer.valid_1') }}
                      </div>
                    </div>


                    <div class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <input
                          :disabled="$v.fields.name.ru.$model"
                          v-if="isPrivate"
                          id="name-ru"
                          v-model="$v.fields.name.ru.$model"
                          type="text"
                          name="company_name_ru"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('name.ru', 'required')}"
                          :placeholder="$t('private_customer.user_name_ru')"
                        />
                        <input
                          :disabled="$v.fields.name.ru.$model"
                          v-else
                          id="name-ru"
                          v-model="$v.fields.name.ru.$model"
                          type="text"
                          name="company_name_ru"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('name.ru', 'required')}"
                          :placeholder="$t('private_customer.user_name_ru')"
                        />
                      </float-label>  
                      <div v-if="isInvalidField('name.ru', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col-md-6 mb-4 px-md-2">
                      <label>Կազմակերպության տեսակը</label>
                      <select
                        :disabled="$v.fields.company_type.hy.$model"
                        v-if="isPrivate"
                        id="company-type"
                        v-model="$v.fields.company_type.hy.$model"
                        name="company_type"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('company_type.hy', 'required')}"
                      >
                        <option value="" disabled>Ընտրել տեսակ</option>
                        <option value="ՍՊԸ">ՍՊԸ</option>
                        <option value="Ա/Ձ">Ա/Ձ</option>
                        <option value="ԲԲԸ">ԲԲԸ</option>
                        <option value="Ա/Կ">Ա/Կ</option>
                        <option value="ՓԲԸ">ՓԲԸ</option>
                        <option value="Հիմնադրամ">Հիմնադրամ</option>
                        <option value="Հ/Կ">Հ/Կ</option>
                        <option value="other">Այլ</option>
                      </select>
                      <select
                        v-else
                        :disabled="$v.fields.company_type.hy.$model"
                        id="company-type"
                        v-model="$v.fields.company_type.hy.$model"
                        name="company_type"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('company_type.hy', 'required')}"
                      >
                        <option value="" disabled>Ընտրել տեսակ</option>
                        <option value="ՍՊԸ">ՍՊԸ</option>
                        <option value="ՊՈԱԿ">ՊՈԱԿ</option>
                        <option value="ՓԲԸ">ՓԲԸ</option>
                        <option value="ՀՈԱԿ">ՀՈԱԿ</option>
                        <option value="Հիմնադրամ">Հիմնադրամ</option>
                        <option value="Համայնքապետարան">Համայնքապետարան</option>
                        <option value="Քաղաքապետարան">Քաղաքապետարան</option>
                        <option value="Կոմիտե">Կոմիտե</option>
                      </select>
                      <div v-if="isInvalidField('company_type.hy', 'required')"
                        class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>

                    <div class="col-md-6 mb-4 px-md-2">
                      <label>Тип компании</label>
                      <select
                        :disabled="$v.fields.company_type.ru.$model"
                        v-if="isPrivate"
                        id="company-type-ru"
                        v-model="$v.fields.company_type.ru.$model"
                        name="company_type_ru"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('company_type.ru', 'required')}"
                      >
                        <option value="" disabled>Выбрать</option>
                        <option value="ООО">ООО</option>
                        <option value="И/П">И/П</option>
                        <option value="ОАО">ОАО</option>
                        <option value="П/О">П/О</option>
                        <option value="К/О">К/О</option>
                        <option value="ЗАО">ЗАО</option>
                        <option value="ФОНД">ФОНД</option>
                        <option value="O/О">O/О</option>
                      </select>
                      <select
                        v-else
                        :disabled="$v.fields.company_type.ru.$model"
                        id="company-type-ru"
                        v-model="$v.fields.company_type.ru.$model"
                        name="company_type_ru"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('company_type.ru', 'required')}"
                      >
                        <option value="" disabled>Выбрать</option>
                        <option value="ООО">ООО</option>
                        <option value="ГНКО">ГНКО</option>
                        <option value="ЗАО">ЗАО</option>
                        <option value="ОНКО">ОНКО</option>
                        <option value="фонд">фонд</option>
                        <option value="община">община</option>
                        <option value="муниципалитет">муниципалитет</option>
                        <option value="комитет">комитет</option>
                      </select>
                      <div v-if="isInvalidField('company_type.ru', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- User Name -->
                <div v-else>
                  <div class="form-row">
                    <div class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <input
                          :disabled="!isCoordinator && $v.fields.name.hy.$model"
                          v-model="$v.fields.name.hy.$model"
                          :placeholder="$t('private_customer.user_name_surname')"
                          type="text"
                          name="company_name"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('name.hy', 'required')}"
                        />
                      </float-label>  
                      <div v-if="isInvalidField('name.hy', 'required')"
                        class="small text-danger">{{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                    <div class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <input
                          :disabled="!isCoordinator && $v.fields.name.ru.$model !==''"
                          v-model="$v.fields.name.ru.$model"
                          type="text"
                          name="company_name_ru"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('name.ru', 'required')}"
                          :placeholder="$t('private_customer.user_name_surname_ru')"
                        />
                      </float-label>   
                      <div v-if="isInvalidField('name.ru', 'required')"
                        class="small text-danger">{{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Address HY-RU -->
                <div class="form-row">
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        :placeholder="$t('state_customer.pl_state')"
                        :disabled="!isCoordinator"
                        v-model="$v.fields.region.hy.$model"
                        type="text"
                        name="company_region"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('region.hy', 'required')}"
                      />
                    </float-label> 
                    <div v-if="isInvalidField('region.hy', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        :disabled="!isCoordinator"
                        v-model="$v.fields.region.ru.$model"
                        :placeholder="$t('state_customer.pl_state_rus')"
                        type="text"
                        name="company_region_ru"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('region.ru', 'required')}"
                        value=""
                      />
                    </float-label>   
                    <div v-if="isInvalidField('region.ru', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        :disabled="!isCoordinator"
                        v-model="$v.fields.city.hy.$model"
                        :placeholder="$t('state_customer.pl_city')"
                        type="text"
                        name="company_city"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('city.hy', 'required')}"
                      />
                    </float-label>   
                    <div v-if="isInvalidField('city.hy', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        :disabled="!isCoordinator"
                        v-model="$v.fields.city.ru.$model"
                        :placeholder="$t('state_customer.pl_city_rus')"
                        type="text"
                        name="company_city_ru"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('city.ru', 'required')}"
                      />
                    </float-label> 
                    <div v-if="isInvalidField('city.ru', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        :disabled="!isCoordinator"
                        v-model="$v.fields.address.hy.$model"
                        :placeholder="$t('state_customer.pl_address')"
                        type="text"
                        name="company_address"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('address.hy', 'required')}"
                      />
                    </float-label>    
                    <div v-if="isInvalidField('address.hy', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        :disabled="!isCoordinator"
                        v-model="$v.fields.address.ru.$model"
                        :placeholder="$t('state_customer.pl_address_rus')"
                        type="text"
                        name="company_address_ru"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('address.ru', 'required')}"
                      />
                    </float-label>   
                    <div v-if="isInvalidField('address.ru', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                </div>

                <!-- Soc. Card / Passport Details -->
                <div v-if="type === 'person'">
                  <!-- Soc. Card Number / Passport Number -->
                  <div class="form-row">
                    <div class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <the-mask
                          :disabled="!isCoordinator"
                          mask="###############################"
                          id="id_card_number"
                          v-model="$v.fields.id_card_number.$model"
                          type="text"
                          :placeholder="$t('private_customer.id_card_number')"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('id_card_number', 'required')}"
                          name="id_card_number"
                        />
                      </float-label>   
                      <div v-if="isInvalidField('id_card_number', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                    </div>
                    <div class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <the-mask
                          :disabled="!isCoordinator"
                          mask="###############################"
                          id="passport_serial"
                          v-model="$v.fields.passport.serial_number.$model"
                          type="text"
                          :placeholder="$t('private_customer.passport.serial_number')"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('passport.serial_number', 'required')}"
                          name="passport_serial"
                        />
                      </float-label>   
                      <div v-if="isInvalidField('passport.serial_number', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                    </div>
                  </div>
                  <!-- Passport Details -->
                  <div class="form-row">
                    <div class="col-md-4 mb-4 px-md-2">
                      <float-label class="w-100">
                        <input
                          :disabled="!isCoordinator"
                          id="passport_start"
                          v-model="$v.fields.passport.given_at.$model"
                          type="text"
                          v-mask="'##/##/####'"
                          :placeholder="$t('private_customer.passport.given_at')"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('passport.given_at', 'required')}"
                          name="passport_start"
                        />
                      </float-label>  
                      <div v-if="isInvalidField('passport.given_at', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                      <div v-if="isInvalidField('passport.given_at', 'validDate')" class="small text-danger">{{ $t('private_customer.valid_phone') }}</div>
                    </div>
                    <div class="col-md-4 mb-4 px-md-2">
                      <float-label class="w-100">
                        <input
                          id="passport_end"
                          :disabled="!isCoordinator"
                          v-model="$v.fields.passport.valid_until.$model"
                          type="text"
                          v-mask="'##/##/####'"
                          :placeholder="$t('private_customer.passport.valid_until')"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('passport.valid_until', 'required')}"
                          name="passport_end"
                        />
                      </float-label>   
                      <div v-if="isInvalidField('passport.valid_until', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                      <div v-if="isInvalidField('passport.valid_until', 'validDate')" class="small text-danger">{{ $t('private_customer.valid_phone') }}</div>
                    </div>
                    <div class="col-md-4 mb-4 px-md-2">
                      <float-label class="w-100">
                        <the-mask 
                          mask="###"
                          v-model="$v.fields.passport.from.$model"
                          id="passport_who"
                          :placeholder="$t('private_customer.passport.from')"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('passport.from', 'required')}"
                          name="passport_who"
                        />
                      </float-label>    
                      <div v-if="isInvalidField('passport.from', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                    </div>
                  </div>
                </div>

                <!-- Bank Details -->
                <div class="form-row">
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        :disabled="!isCoordinator"
                        id="bank-name"
                        v-model="$v.fields.bank_name.hy.$model"
                        :placeholder="isPrivate ? $t('private_customer.pl_bank') : $t('state_customer.pl_bank')"
                        type="text"
                        name="bank_name"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('bank_name.hy', 'required')}"
                      />
                    </float-label>   
                    <div v-if="isInvalidField('bank_name.hy', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        :disabled="!isCoordinator"
                        v-model="$v.fields.bank_name.ru.$model"
                        :placeholder="isPrivate ? $t('private_customer.pl_bank_rus') : $t('state_customer.pl_bank_rus')"
                        type="text"
                        name="bank_name_ru"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('bank_name.ru', 'required')}"
                      />
                    </float-label>  
                    <div v-if="isInvalidField('bank_name.ru', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                </div>

                <!-- Bank Account Details -->
                <div v-if="type === 'legalEntity'">
                  <div class="form-row" >
                    <div class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <the-mask 
                          :disabled="!isCoordinator"
                          id="bank-account"
                          v-model="$v.fields.bank_account.$model"
                          :placeholder="$t('state_customer.pl_account_number')"
                          type="text"
                          min="0"
                          name="bank_account"
                          maxlength="16"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('bank_account', 'required')}"
                          mask="###############################"
                        />
                      </float-label>  
                      <div v-if="isInvalidField('bank_account', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                    <div class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <input
                          :disabled="fields.is_resident"
                          id="tin"
                          v-model="$v.fields.tin.$model"
                          :placeholder="$t('state_customer.pl_hvhh')"
                          type="text"
                          name="hvhh"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('tin', 'required')}"
                          maxlength="8"
                        />
                      </float-label>   
                      <div v-if="isInvalidField('tin', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6 mb-4 px-md-2">
                      <label>Կազմակերպության գրանցում</label>
                      <div class="d-flex">
                        <label class="d-flex align-items-center mr-4">
                          <input type="radio" :value="true" v-model="fields.is_resident">
                          <span class="ml-2">ՀՀ ռեզիդենտ</span>
                        </label>
                        <label class="d-flex align-items-center">
                          <input type="radio" :value="false" v-model="fields.is_resident">
                          <span class="ml-2">Այլ</span>
                        </label>
                      </div>
                    </div>
                    <div v-if="!fields.is_resident" class="col-md-6 mb-4 px-md-2">
                      <float-label class="w-100">
                        <input
                          id="country"
                          v-model="$v.fields.country.$model"
                          placeholder="Գրանցման երկիր"
                          type="text"
                          name="country"
                          class="auth-input mb-0"
                          :class="{'border-danger': isInvalidField('country', 'required')}"
                        />
                      </float-label>
                      <div v-if="isInvalidField('country', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                  </div>

                  <div v-if="!fields.is_resident && fields.verification_status !== 'verified'" class="form-row">
                    <div class="col-12 mb-4 px-md-2">
                      <div v-if="fields.verification_status === 'pending_review'" class="alert alert-warning d-flex align-items-center mb-3" style="width: fit-content;">
                        Հայտը ուղարկված է ստուգման, սպասվում է ադմինիստրատորի հաստատմանը
                      </div>
                      <div v-else-if="fields.verification_status === 'rejected'" class="alert alert-danger mb-3" style="width: fit-content;">
                        Հայտը մերժվել է<span v-if="fields.verification_note">՝ {{ fields.verification_note }}</span>. Կարող եք ուղարկել կրկին՝ ուղղելով տվյալները։
                      </div>
                      <p class="small text-muted mb-2">
                        Ուղարկեք ստուգման հայտ՝ վերևում նշված անվանման, ՀՎՀՀ-ի և գրանցման երկրի հիման վրա։ Ցանկության դեպքում կցեք հաստատող փաստաթուղթ (գրանցման վկայական և այլն)։
                      </p>
                      <div class="d-flex align-items-center flex-wrap">
                        <input type="file" ref="nonresidentDocument" @change="onNonresidentDocumentChange" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" class="mr-3 mb-2" />
                        <button type="button" class="btn btn-primary mb-2" :disabled="submittingNonresidentVerification" @click="submitNonresidentVerification">
                          <span v-if="submittingNonresidentVerification" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                          Ուղարկել ստուգման
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col-md-6 mb-3 px-md-3">
                      <label>{{$t('state_customer.pl_name_surname')}}</label>
                      <input
                        v-if="isPrivate"
                        :disabled="!isCoordinator"
                        id="director-name-hy"
                        v-model="$v.fields.director_name.hy.$model"
                        :placeholder="$t('state_customer.pl_name_surname')"
                        type="text"
                        name="director_name"
                        class="form-control"
                        :class="{'border-danger': isInvalidField('director_name.hy', 'required')}"
                      />
                      <input
                        v-else
                        :disabled="!isCoordinator"
                        id="pl-name-hy"
                        v-model="$v.fields.director_name.hy.$model"
                        :placeholder="$t('state_customer.pl_name_surname')"
                        type="text"
                        name="director_name"
                        class="form-control"
                        :class="{'border-danger': isInvalidField('director_name.hy', 'required')}"
                      />
                      <div v-if="isInvalidField('director_name.hy', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                    <div class="col-md-6 mb-3 px-md-3">
                      <label>{{$t('state_customer.pl_name_surname_rus')}}</label>
                      <input
                        v-if="isPrivate"
                        :disabled="!isCoordinator"
                        id="director-name-ru"
                        v-model="$v.fields.director_name.ru.$model"
                        :placeholder="$t('state_customer.pl_name_surname')"
                        type="text"
                        name="director_name"
                        class="form-control"
                        :class="{'border-danger': isInvalidField('director_name.ru', 'required')}"
                      />
                      <input
                        v-else
                        :disabled="!isCoordinator"
                        id="director-name-ru"
                        v-model="$v.fields.director_name.ru.$model"
                        :placeholder="$t('state_customer.pl_name_surname')"
                        type="text"
                        name="director_name_ru"
                        class="form-control"
                        :class="{'border-danger': isInvalidField('director_name.ru', 'required')}"
                      />
                      <div v-if="isInvalidField('director_name.ru', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                  </div>
                  <div v-if="!isPrivate" class="form-row">
                    <div class="col-md-6 mb-3 px-md-3">
                      <label>{{$t('state_customer.pl_position')}}</label>
                      <input
                        id="director-name-hy"
                        v-model="$v.fields.director_position.hy.$model"
                        :placeholder="$t('state_customer.pl_position')"
                        type="text"
                        name="director_position"
                        class="auth-input form-control"
                        :class="{'border-danger': isInvalidField('director_position.hy', 'required')}"
                      />
                      <div v-if="isInvalidField('director_position.hy', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                    <div class="col-md-6 mb-3 px-md-3">
                      <label>{{$t('state_customer.pl_position_rus')}}</label>
                      <input
                        id="director-name-ru"
                        v-model="$v.fields.director_position.ru.$model"
                        :placeholder="$t('state_customer.pl_position_rus')"
                        type="text"
                        name="director_position"
                        class="auth-input form-control"
                        :class="{'border-danger': isInvalidField('director_position.ru', 'required')}"
                      />
                      <div v-if="isInvalidField('director_position.ru', 'required')"
                        class="small text-danger">
                        {{ $t('state_customer.valid_1') }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Bank Name -->
                <div class="form-row" v-if="type === 'person'">
                  <div class="col-md-6 mb-4 px-md-2">
                    <float-label class="w-100">
                      <input
                        id="bank-account"
                        v-model="$v.fields.bank_account.$model"
                        :placeholder="$t('state_customer.pl_account_number')"
                        type="number"
                        min="0"
                        name="bank_account"
                        maxlength="16"
                        class="auth-input mb-0"
                        :class="{'border-danger': isInvalidField('bank_account', 'required')}"
                      />
                    </float-label>     
                    <div v-if="isInvalidField('bank_account', 'required')"
                      class="small text-danger">
                      {{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                </div>
              </form>
              <div class="d-flex justify-content-end">
                <button @click="save" type="button" class="button_H36" data-toggle="modal" data-animation="bounce">
                  <span>Պահպանել</span>
                </button>
              </div>  
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import { required, numeric, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'
const validDate = (value, vm) => {
  var date = moment(value, "DD-MM-YYYY");
  var currentDate = moment(new Date());
  var yearDiff = currentDate.year() - date.year();
  if(!date.isValid() || yearDiff > 10) {
    return false
  }
  return true
};
export default {
  name: 'organisationSettings',
  data () {
    return {
      open: false,
      nonresidentDocument: null,
      submittingNonresidentVerification: false,
      dataLoaded: false,
      isInvalidPhone: false,
      isPrivate: false,
      type: 'legalEntity',
      fields: {
        name: {
          hy: '',
          ru: '',
        },
        // email: '',
        phone: '',
        tin: '',
        is_resident: true,
        verification_status: null,
        verification_checked_at: null,
        verification_note: null,
        country: '',
        // passport: {
        //   serial_number: '',
        //   given_at: '',
        //   from: '',
        //   valid_until: '',
        // },
        id_card_number: '',
        bank_account: '',
        region: {
          hy: '',
          ru: '',
        },
        city: {
          hy: '',
          ru: '',
        },
        address: {
          hy: '',
          ru: '',
        },
        bank_name: {
          hy: '',
          ru: '',
        },
        director_name: {
          hy: '',
          ru: '',
        },
        director_position: {
          hy: '',
          ru: '',
        },
        company_type: {
          hy: '',
          ru: '',
        }
      },
      userType: this.$route.params.type,
    }
  },
  watch: {
    me(newValue, oldValue) {
      this.fields.name.hy = newValue.organisation[0].translations.name.hy;
      this.fields.name.ru = newValue.organisation[0].translations.name.ru;
      this.fields.phone = newValue.organisation[0].phone;
      this.fields.tin = newValue.organisation[0].tin;
      this.fields.is_resident = Boolean(newValue.organisation[0].is_resident);
      this.fields.country = newValue.organisation[0].country || '';
      this.fields.verification_status = newValue.organisation[0].verification_status;
      this.fields.verification_checked_at = newValue.organisation[0].verification_checked_at;
      this.fields.verification_note = newValue.organisation[0].verification_note;
      this.fields.bank_account = newValue.organisation[0].bank_account;
      this.fields.region.hy = newValue.organisation[0].translations.region.hy;
      this.fields.region.ru = newValue.organisation[0].translations.region.ru;
      this.fields.city.hy = newValue.organisation[0].translations.city.hy;
      this.fields.city.ru = newValue.organisation[0].translations.city.ru;
      this.fields.address.hy = newValue.organisation[0].translations.address.hy;
      this.fields.address.ru = newValue.organisation[0].translations.address.ru;
      this.fields.bank_name.hy = newValue.organisation[0].translations.bank_name.hy;
      this.fields.bank_name.ru = newValue.organisation[0].translations.bank_name.ru;
      this.fields.director_name.hy = newValue.organisation[0].translations.director_name.hy;
      this.fields.director_name.ru = newValue.organisation[0].translations.director_name.ru;
      this.fields.director_position.hy = this.me.organisation[0].translations.director_position.hy;
      this.fields.director_position.ru = this.me.organisation[0].translations.director_position.ru;
      this.fields.company_type.hy = newValue.organisation[0].translations.company_type.hy;
      this.fields.company_type.ru = newValue.organisation[0].translations.company_type.ru;
      this.$nextTick(function () { this.dataLoaded = true }.bind(this))
    },
  },
  mounted(){
    if(this.me.organisation){
      this.fields.name = this.me.organisation[0].translations.name;
      this.fields.phone = this.me.organisation[0].phone;
      this.fields.tin = this.me.organisation[0].tin;
      this.fields.is_resident = Boolean(this.me.organisation[0].is_resident);
      this.fields.country = this.me.organisation[0].country || '';
      this.fields.verification_status = this.me.organisation[0].verification_status;
      this.fields.verification_checked_at = this.me.organisation[0].verification_checked_at;
      this.fields.verification_note = this.me.organisation[0].verification_note;
      this.fields.bank_account = this.me.organisation[0].bank_account;
      this.fields.region = this.me.organisation[0].translations.region;
      this.fields.city = this.me.organisation[0].translations.city;
      this.fields.address = this.me.organisation[0].translations.address;
      this.fields.bank_name = this.me.organisation[0].translations.bank_name;
      this.fields.director_name = this.me.organisation[0].translations.director_name;
      this.fields.director_position = this.me.organisation[0].translations.director_position;
      this.fields.company_type = this.me.organisation[0].translations.company_type;
      this.$nextTick(function () { this.dataLoaded = true }.bind(this))
    }
  },
  computed: {
    isCoordinator(){
       return +this.me.divisions === 2
    },
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    formatVerificationDate(value) {
      return value ? moment(value).format('DD.MM.YYYY, HH:mm') : '';
    },
    onNonresidentDocumentChange(e) {
      this.nonresidentDocument = e.target.files[0] || null;
    },
    submitNonresidentVerification() {
      this.submittingNonresidentVerification = true;
      const formData = new FormData();
      if (this.nonresidentDocument) {
        formData.append('document', this.nonresidentDocument);
      }
      this.$client.post('participant/submit-nonresident-verification', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(({ data }) => {
        if (data && data.submitted) {
          this.fields.verification_status = 'pending_review';
          this.fields.verification_note = null;
          this.nonresidentDocument = null;
          if (this.$refs.nonresidentDocument) {
            this.$refs.nonresidentDocument.value = '';
          }
          this.$notify({ group: 'foo', type: 'success', text: 'Հայտն ուղարկվել է ստուգման' });
        } else {
          this.$notify({ group: 'foo', type: 'error', text: 'Հնարավոր չեղավ ուղարկել հայտը' });
        }
      }).catch(() => {
        this.$notify({ group: 'foo', type: 'error', text: 'Հնարավոր չեղավ ուղարկել հայտը' });
      }).finally(() => {
        this.submittingNonresidentVerification = false;
      });
    },
    consoleLog(e){
      console.log(e)
    },
    validatePhone (item) {
      const valid = item.valid;
      if (valid !== undefined){
        this.$v.fields.phone.$model = item.number;
        if(!item.valid){
          this.isInvalidPhone = true;
        }
        else{
          this.isInvalidPhone = false;
        }
      }
    },
    save() {
      if(!this.$v.fields.$invalid) {
        $client.put(`organisation`, this.fields).then(({data}) => {
          if(data){
            this.$notify({
              group: 'foo',
              type: 'success',
              text: 'Հաջողությամբ պահպանված է'
            })
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Էլ. հացեն զբաղված է',
            text: 'Կրկին փորձեք!'
          })
        })
      } else {
        this.$v.fields.$touch()
        this.$v.agreeToTerms.$touch()
        this.$v.captcha.$touch()
      }
    },
    isInvalidField (pathToField, validator) {
      const keyArr = pathToField.split('.')
      const field = keyArr.reduce((acc, key) => {
        return acc[key]
      }, this.$v.fields)
      return validator === 'required' ?
        field.$dirty && !field.required :
        field.required && !field[validator]
    }
  },
  validations() {
    const validationRules = {
      fields: {
        name: {
          hy: { required },
          ru: { required },
        },
        phone: { required },
        bank_account: { required, numeric },
        region: {
          hy: { required },
          ru: { required },
        },
        city: {
          hy: { required },
          ru: { required },
        },
        address: {
          hy: { required },
          ru: { required },
        },
        bank_name: {
          hy: { required },
          ru: { required },
        },
      },
    }
    if (this.isPrivate) {
      const privateValidationRules = {
        passport: {
          serial_number: { required },
          given_at: { required, validDate },
          from: { required, numeric },
          valid_until: { required, validDate },
        },
        id_card_number: { required, numeric }
      }
      validationRules.fields = Object.assign(validationRules.fields, privateValidationRules);
      return validationRules;
    } else {
      const privateValidationRules = {
        director_position: {
          hy: { required },
          ru: { required },
        },
        company_type: {
          hy: { required },
          ru: { required },
        },
        director_name: {
          hy: { required },
          ru: { required },
        },
        tin: { required, numeric: (value) => !this.fields.is_resident || numeric(value) },
        country: { required: requiredIf(() => !this.fields.is_resident) },
      }
      validationRules.fields = Object.assign(validationRules.fields, privateValidationRules);
      return validationRules;
    }
  }
}
</script>
<style scoped>
.card{
  margin-bottom: 12px;
}
</style>